/* tslint:disable */
/* eslint-disable */
/**
 * orderBasisManage API
 * 発注根拠に関する情報を操作する
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 発注根拠取得APIのレスポンス
 * @export
 * @interface GetOrderBasisResponse
 */
export interface GetOrderBasisResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderBasisResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderBasisResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderBasisResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderBasis}
     * @memberof GetOrderBasisResponse
     */
    'result': OrderBasis;
}
/**
 * 
 * @export
 * @interface OrderBasis
 */
export interface OrderBasis {
    /**
     * 発注根拠ID
     * @type {string}
     * @memberof OrderBasis
     */
    'orderBasisId': string;
    /**
     * 発注確定時最新在庫数
     * @type {number}
     * @memberof OrderBasis
     */
    'snapshotLatestInventoryAmount': number;
    /**
     * 発注確定時最新在庫年月日
     * @type {number}
     * @memberof OrderBasis
     */
    'snapshotExecutionDate': number;
    /**
     * 発注確定時Package
     * @type {number}
     * @memberof OrderBasis
     */
    'snapshotPackage': number;
    /**
     * 発注確定時MOQ
     * @type {number}
     * @memberof OrderBasis
     */
    'snapshotMoq'?: number;
    /**
     * 発注確定時リードタイム
     * @type {number}
     * @memberof OrderBasis
     */
    'userAdjustedLeadTime': number;
    /**
     * 発注確定時リードタイム単位
     * @type {string}
     * @memberof OrderBasis
     */
    'userAdjustedLeadTimeUnit': string;
    /**
     * 発注確定時標準在庫指数Min
     * @type {number}
     * @memberof OrderBasis
     */
    'userAdjustedStdInventoryIndexMin': number;
    /**
     * 発注確定時標準在庫指数Max
     * @type {number}
     * @memberof OrderBasis
     */
    'userAdjustedStdInventoryIndexMax': number;
    /**
     * 発注確定時標準在庫指数単位
     * @type {string}
     * @memberof OrderBasis
     */
    'userAdjustedStdInventoryIndexUnit': string;
    /**
     * 
     * @type {Array<OrderBasisNextMonthlyInfo>}
     * @memberof OrderBasis
     */
    'nextMonthlyInfos': Array<OrderBasisNextMonthlyInfo>;
    /**
     * 
     * @type {Array<OrderBasisPastMonthlyInfo>}
     * @memberof OrderBasis
     */
    'pastMonthlyInfos': Array<OrderBasisPastMonthlyInfo>;
    /**
     * 
     * @type {Array<OrderBasisCustomerAnnounceDaily>}
     * @memberof OrderBasis
     */
    'customerAnnounceDaily'?: Array<OrderBasisCustomerAnnounceDaily>;
}
/**
 * 発注根拠の日別内示情報
 * @export
 * @interface OrderBasisCustomerAnnounceDaily
 */
export interface OrderBasisCustomerAnnounceDaily {
    /**
     * 客先内示日別ID
     * @type {string}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastDailyId': string;
    /**
     * 客先内示受領年
     * @type {number}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastReceivedYear': number;
    /**
     * 客先内示受領月
     * @type {number}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastReceivedMonth': number;
    /**
     * 客先内示対象年
     * @type {number}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastTargetYear': number;
    /**
     * 客先内示対象月
     * @type {number}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastTargetMonth': number;
    /**
     * 客先内示対象日
     * @type {number}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastTargetDay': number;
    /**
     * 客先内示数量
     * @type {number}
     * @memberof OrderBasisCustomerAnnounceDaily
     */
    'customerForecastAmount': number;
}
/**
 * 以後日次情報の型定義
 * @export
 * @interface OrderBasisNextDailyInfo
 */
export interface OrderBasisNextDailyInfo {
    /**
     * 対象日
     * @type {number}
     * @memberof OrderBasisNextDailyInfo
     */
    'orderBasisTargetDay': number;
    /**
     * 発注確定時の入荷情報
     * @type {number}
     * @memberof OrderBasisNextDailyInfo
     */
    'snapshotArrivalAmount': number;
}
/**
 * 
 * @export
 * @interface OrderBasisNextMonthlyInfo
 */
export interface OrderBasisNextMonthlyInfo {
    /**
     * 対象年
     * @type {number}
     * @memberof OrderBasisNextMonthlyInfo
     */
    'orderBasisTargetYear': number;
    /**
     * 対象月
     * @type {any}
     * @memberof OrderBasisNextMonthlyInfo
     */
    'orderBasisTargetMonth': any;
    /**
     * 発注確定時客先内示（ユーザー操作後）
     * @type {number}
     * @memberof OrderBasisNextMonthlyInfo
     */
    'userAdjustedCustomerForecastAmount': number;
    /**
     * 発注確定時オリジナル客先内示
     * @type {number}
     * @memberof OrderBasisNextMonthlyInfo
     */
    'snapshotCustomerForecastAmount': number;
    /**
     * 発注確定時予末在庫
     * @type {number}
     * @memberof OrderBasisNextMonthlyInfo
     */
    'snapshotPreInventoryAmount': number;
    /**
     * 以後日次データ
     * @type {Array<OrderBasisNextDailyInfo>}
     * @memberof OrderBasisNextMonthlyInfo
     */
    'dailyInfos'?: Array<OrderBasisNextDailyInfo>;
}
/**
 * 発注の過去月次情報
 * @export
 * @interface OrderBasisPastMonthlyInfo
 */
export interface OrderBasisPastMonthlyInfo {
    /**
     * 対象年
     * @type {number}
     * @memberof OrderBasisPastMonthlyInfo
     */
    'orderBasisTargetYear': number;
    /**
     * 対象月
     * @type {any}
     * @memberof OrderBasisPastMonthlyInfo
     */
    'orderBasisTargetMonth': any;
    /**
     * 発注確定時客先内示
     * @type {number}
     * @memberof OrderBasisPastMonthlyInfo
     */
    'snapshotCustomerForecastAmount': number;
    /**
     * 発注確定時販売実績
     * @type {number}
     * @memberof OrderBasisPastMonthlyInfo
     */
    'snapshotSalesResultAmount': number;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}

/**
 * OrderBasisApi - axios parameter creator
 * @export
 */
export const OrderBasisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注根拠取得
         * @param {string} orderBasisId 発注根拠ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBasis: async (orderBasisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderBasisId' is not null or undefined
            assertParamExists('getOrderBasis', 'orderBasisId', orderBasisId)
            const localVarPath = `/order-basis/{order_basis_id}`
                .replace(`{${"order_basis_id"}}`, encodeURIComponent(String(orderBasisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderBasisApi - functional programming interface
 * @export
 */
export const OrderBasisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderBasisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注根拠取得
         * @param {string} orderBasisId 発注根拠ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderBasis(orderBasisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderBasisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderBasis(orderBasisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderBasisApi.getOrderBasis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderBasisApi - factory interface
 * @export
 */
export const OrderBasisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderBasisApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注根拠取得
         * @param {string} orderBasisId 発注根拠ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBasis(orderBasisId: string, options?: any): AxiosPromise<GetOrderBasisResponse> {
            return localVarFp.getOrderBasis(orderBasisId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderBasisApi - object-oriented interface
 * @export
 * @class OrderBasisApi
 * @extends {BaseAPI}
 */
export class OrderBasisApi extends BaseAPI {
    /**
     * 
     * @summary 発注根拠取得
     * @param {string} orderBasisId 発注根拠ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderBasisApi
     */
    public getOrderBasis(orderBasisId: string, options?: RawAxiosRequestConfig) {
        return OrderBasisApiFp(this.configuration).getOrderBasis(orderBasisId, options).then((request) => request(this.axios, this.basePath));
    }
}



